import axios from "axios";

let logoutHandler = null;

export const setLogoutHandler = (handler) => {
  logoutHandler = handler;
};

const instanceAxios = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

instanceAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

instanceAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && logoutHandler) {
      logoutHandler("Session expirée ou accès refusé.");
    }
    return Promise.reject(error);
  }
);

export default instanceAxios;
